module.exports = __webpack_public_path__ + "img/menu-icon-4-4.23b04412.svg";